<template>
    <div class="wrapper">
        <div v-if="detail" class="notice-detail padding-sm margin-bottom-sm flex-sub">
            <div class="flex align-start justify-between margin-bottom-sm">
                <h3 class="notice-title">{{ detail.title }}<span>({{ detail.state | status }})</span></h3>
                <el-button class="blue-btn" round type="primary" @click="$router.go(-1)"
                >返回
                </el-button
                >

            </div>
            <div v-if="detail.state === 2" class="notice-reason">
                拒绝原因：{{ detail.state_msg }}
            </div>
            <el-image class="avatar"  v-if="detail.images" :src="detail.images[0]"></el-image>
            <div class="notice-info" >发布时间：{{detail.create_time}}</div>
            <div class="notice-info" v-html="detail.content"></div>
            <div class="flex justify-end margin-top">
                <el-button v-if="detail.state === 1" class="goback" round @click="apply(2)">拒绝
                </el-button>
                <el-button v-if="detail.state === 1" class="line-btn margin-left-xs" round @click="apply(3)">通过
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {examineActiveData, getActiveDetail} from '@/api/organiz'

export default {
    name: "detail",
    components: {},
    data() {
        return {
            keyWord: '',
            detail: null,
        }
    },
    created() {
        this.$emit('setIndex', [5, 1], '组织动态')
        this.getDetail()
    },
    computed: {
        id() {
            return this.$route.params.id
        },
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        apply(state) {
            if (state === 3) {
                this.$confirm(`你确定通过该组织动态吗?`, '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.submitApply(state, '')
                })
            } else {
                this.$prompt('请输入拒绝原因', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '请输入拒绝原因'
                }).then(({value}) => {
                    this.submitApply(state, value)
                })
            }

        },
        async submitApply(state, value) {
            let _state = await examineActiveData(this.id, value, state)
            if (_state.status === 200) {
                this.$message.success(_state.msg)
                this.$router.go(-1)
            }
        },
        async getDetail() {
            let _data = await getActiveDetail(this.id)
            this.detail = _data.data
        },
    },
    filters: {
        status(type) {
            switch (Number(type)) {
                case 1:
                    return "待审核";
                case 2:
                    return "审核驳回";
                default:
                    return "审核通过";
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.wrapper {
    .notice-detail {
        background: #fff;
        border-radius: 10px;

        .notice-title {
            width: 80%;
            font-size: 26px;
            line-height: 40px;
            color: #333333;
            span{
                font-size: 16px;
                color: #fc4902;
            }
        }

        .goback {
            background: #0a2240;
            border: 1px solid #0a2240;
            width: 100px;
            color: #FFFFFF;
        }

        .notice-num {
            i {
                color: #ffb400;

                &.active {
                    color: #fc4902;
                }
            }
        }
    }
    .avatar {
        width: 154px;
        height: 116px;
    }
    .notice-reason{
        border: 1px dashed #fc4902;
        padding: 10px;
        margin-bottom: 10px;
    }
    .feedback-box {
        background: #fff;
        border-radius: 10px;

        .feedback-title {
            line-height: 40px;
            font-size: 26px;
        }

        .feedback-export {
            width: 200px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
        }

        .notice-num {
            i {
                color: #ffb400;

                &.active {
                    color: #fc4902;
                }
            }
        }

        .feedback-search {
            .el-input__inner {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }

            .el-button {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                background: #0a2240;
                border: 0;
                font-size: 16px;
            }
        }
    }
}
</style>